import { render, staticRenderFns } from "./CreateSlider.vue?vue&type=template&id=2d3b5136&scoped=true&"
import script from "./CreateSlider.vue?vue&type=script&lang=js&"
export * from "./CreateSlider.vue?vue&type=script&lang=js&"
import style0 from "./CreateSlider.vue?vue&type=style&index=0&id=2d3b5136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3b5136",
  null
  
)

export default component.exports